import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetLocateUs =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.locate_us.get,
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageLocateUs =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const data = {};

      if (editMode && values?.id) data.id = values.id;
      if (values.name) data.name = values.name.trim();
      if (values.zone) data.zone = values.zone.trim();
      // Optional text fields are sent even when blank, exactly as the social
      // links below are. Omitting them would leave the previous value in the
      // row, so an editor could never clear one once it had been filled.
      const optionalFields = ["location_name", "map_link"];
      optionalFields.forEach((field) => {
        if (values[field] !== undefined) {
          data[field] = values[field]?.trim() || "";
        }
      });
      const socialFields = [
        "facebook_url",
        "instagram_url",
        "twitter_url",
        "youtube_url",
        "linkedin_url",
      ];
      socialFields.forEach((field) => {
        if (values[field] !== undefined) {
          data[field] = values[field]?.trim() || "";
        }
      });
      if (values.display_order !== undefined) data.display_order = values.display_order;
      if (values.is_active !== undefined) data.is_active = Boolean(values.is_active);

      const route = editMode ? UrlApi.locate_us.edit : UrlApi.locate_us.add;
      const response = await PostFunction({
        data,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditLocateUs =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const data = {
        id,
        [nameFailed]: nameFailed === "is_active" ? Boolean(dataFailed) : dataFailed,
      };

      const response = await PostFunction({
        data,
        Route: UrlApi.locate_us.edit,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteLocateUs =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.locate_us.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch,
      });

      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
